// extracted by mini-css-extract-plugin
export var container = "style-module--container--334f1";
export var thumbnail = "style-module--thumbnail--0af78";